import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseService} from './base.service';
import {SuggestionRequest, SuggestionStatus, TermSuggestion} from '@twpub/core/models/term-suggestion';
import {HttpParams} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class SuggestionService extends BaseService {
  constructor(injector: Injector) {
    super(injector);
  }

  submit(request: SuggestionRequest): Observable<TermSuggestion> {
    return this.http.post<TermSuggestion>(this.url('suggestions'), request);
  }

  list(status?: SuggestionStatus): Observable<TermSuggestion[]> {
    let params = new HttpParams();
    if (status) {
      params = params.set('status', status);
    }
    return this.http.get<TermSuggestion[]>(this.url('suggestions'), {params});
  }

  approve(id: string, comment?: string): Observable<TermSuggestion> {
    return this.http.put<TermSuggestion>(this.url(`suggestions/${id}/approve`), {comment});
  }

  deny(id: string, comment?: string): Observable<TermSuggestion> {
    return this.http.put<TermSuggestion>(this.url(`suggestions/${id}/deny`), {comment});
  }

  sendToTermWeb(id: string): Observable<TermSuggestion> {
    return this.http.put<TermSuggestion>(this.url(`suggestions/${id}/send`), {});
  }
}
